import './css/index.sass';
import Waves from './directives/waves-directive.js';

export default Waves;
